module.exports = __webpack_public_path__ + "img/custom_client_seed_1_es.de21dea4.png";